export function formatLocalISODateTimeWithZone(date) {
    const [day, month, year] = date
        .toLocaleDateString(undefined, {
        day: `2-digit`,
        month: `2-digit`,
        year: `numeric`,
    })
        .split(`/`);
    const datePart = `${year}-${month}-${day}`;
    const timePart = date.toLocaleTimeString(undefined, {
        hour: `2-digit`,
        minute: `2-digit`,
        second: `2-digit`,
    });
    const timeZonePart = Intl.DateTimeFormat(undefined, {
        timeZoneName: `short`,
    })
        .formatToParts(date)
        .find((part) => part.type === `timeZoneName`)?.value ?? ``;
    const result = `${datePart} ${timePart} ${timeZonePart}`;
    return result;
}
export function computeResendWait(lastSentAt, defaultRetryAfterMinutes) {
    const safeDefault = Number.isFinite(defaultRetryAfterMinutes) ? Math.max(0, defaultRetryAfterMinutes) : 0;
    const baseDelayMs = safeDefault * 60 * 1_000;
    let remainingMs = baseDelayMs;
    if (lastSentAt) {
        const parsed = Date.parse(lastSentAt);
        if (!Number.isNaN(parsed)) {
            const elapsed = Math.max(0, Date.now() - parsed);
            remainingMs = Math.max(0, baseDelayMs - elapsed);
        }
    }
    let minutes = 0;
    if (remainingMs > 0) {
        minutes = Math.floor(remainingMs / 60_000);
    }
    const milliseconds = Math.max(10_000, remainingMs);
    return { minutes, milliseconds };
}
//# sourceMappingURL=date-time.js.map